import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HelpersService {

  constructor() { }

  public static static(path: string) {
    return environment.url.static + '/' + path;
  }

  public static storage(path: string) {
    return environment.url.storage + '/' + path;
  }

  public static api(path: string) {
    return environment.url.base + '/' + path;
  }

}
